import { render, staticRenderFns } from "./hrd-training-center-detail.vue?vue&type=template&id=2267f54f&scoped=true"
import script from "./hrd-training-center-detail.vue?vue&type=script&lang=js"
export * from "./hrd-training-center-detail.vue?vue&type=script&lang=js"
import style0 from "./hrd-training-center-detail.vue?vue&type=style&index=0&id=2267f54f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2267f54f",
  null
  
)

export default component.exports